<template>
  <BaseLayout>
    <div class="card">

      <div class="card-body">
        <div class="row gy-sm-1">
          <div class="col-md-3">
            <div class="input-group input-group-merge shadow-none">
              <input type="text" class="form-control border-1 py-2" placeholder="Поиск по названию"
                     v-model="searchData.name" @change="search">
            </div>
          </div>
        </div>
        <div v-if="!items.length && !loading" class="mt-7">
          Задачи не найдены
        </div>
      </div>
      <LoadingBlock :loading="loading">
        <div class="table-responsive text-nowrap">
          <table class="table">
            <tbody class="">
            <tr v-for="(item, index) in items" :key="index" class="cursor-pointer" @click="openTask(item)">
              <td>{{ item.name }}</td>
              <td>{{ item.task_result_description }}</td>
              <td>{{ item.task_progress }} %</td>
              <td>{{ item.task_info }}</td>
              <td>{{ formatDate(item.start_time) }}</td>
              <td>{{ formatDate(item.end_time) }}</td>
            </tr>
            </tbody>
          </table>

          <BasePagination :info="paginationInfo" ref="productsPagination" @changePage="changePage">
          </BasePagination>
        </div>
      </LoadingBlock>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue'
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import BasePagination from "@/components/list/Pagination.vue"
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {getList} from "@/api/task";

export default {
  name: 'TasksView',
  components: {LoadingBlock, BaseLayout, BasePagination},
  data() {
    return {
      items: [],
      loading: true,
      paginationInfo: {},
      searchData: {
        name: '',
      },
      task_results : {
        'in_progress': 'В процессе',
        'success': 'Успешно выполнена',
        'failure': 'Произошла ошибка',
      }
    }
  },
  methods: {
    async getItems() {
      this.loading = true
      const result = await getList(user.active_company, this.$route.query)
      this.paginationInfo = {
        total: result.data.total,
        pages: result.data.pages,
        page: result.data.page,
        size: result.data.size
      }
      this.items = result.data.items
      this.items.forEach(item => {
        item.task_result_description = this.task_results[item.task_result]
      })
      this.loading = false
    },
    async search() {
      const query = {...this.$route.query}
      delete query.page
      Object.entries(this.searchData).forEach(([key, value]) => {
        if (value) {
          query[key] = value
        } else {
          delete query[key]
        }
      });
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...query
        }
      })

    },
    setSearch() {
      if (this.$route.query.name) {
        this.searchData.name = this.$route.query.name
      } else {
        this.searchData.name = ''
      }
    },
    async changePage(page) {
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: page
        }
      });
    },
    async openTask(item) {
      await this.$router.push({name: 'task-detail', params: {id: item.id}})
    },
    setPageInfo() {
      PageInfo.title = 'Задачи'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: PageInfo.title
        }
      ]
    },
    formatDate(isoString) {
      if (!isoString){
        return ''
      }
      const date = new Date(isoString);
      // This gets the day, month, and year
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      // Construct the desired format
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
  },
  async mounted() {
    this.setPageInfo()
    this.setSearch()
    await user.getUserBase()
    await this.getItems()
  },
  watch: {
    '$route'() {
      this.setSearch()
      this.setPageInfo()
      this.getItems()
    }
  }
}
</script>